import { useState } from "react";
import api from "../api";
import BookingModal from "./BookingModal";

export default function PublicSearch() {
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const isDateValid = () => {
    if (!dateDebut || !dateFin) return false;
    return new Date(dateFin) > new Date(dateDebut);
  };

    const search = async () => {
    if (!dateDebut || !dateFin) return;

    setLoading(true);

    try {
      const res = await api.get("/public/search", {
        params: {
          date_debut: dateDebut,
          date_fin: dateFin
        }
      });

      setResults(res.data);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  const nights = () => {
    if (!dateDebut || !dateFin) return 0;
    const d1 = new Date(dateDebut);
    const d2 = new Date(dateFin);
    return Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24));
  };

  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO */}
      <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-12 text-center">
        <h1 className="text-4xl font-bold mb-2">
          Réservez votre séjour parfait
        </h1>
        <p className="opacity-90">
          Confort, simplicité et disponibilité en temps réel
        </p>
      </div>

      {/* SEARCH */}
      <div className="max-w-5xl mx-auto -mt-10 bg-white shadow-xl rounded-2xl p-5 flex flex-col md:flex-row gap-3 items-center">

        <input
          type="date"
          min={new Date().toISOString().split("T")[0]}
          className="border p-3 rounded-xl w-full"
          onChange={e => setDateDebut(e.target.value)}
        />

        <input
          type="date"
          min={dateDebut || new Date().toISOString().split("T")[0]}
          className="border p-3 rounded-xl w-full"
          onChange={e => setDateFin(e.target.value)}
        />

        <button
          disabled={!isDateValid()}
          onClick={search}
          className={`px-6 py-3 rounded-xl text-white w-full md:w-auto ${
            !isDateValid()
              ? "bg-gray-300 cursor-not-allowed opacity-70"
              : "bg-indigo-600 hover:bg-indigo-700"
          }`}
        >
          🔍 Rechercher
        </button>
      </div>

      {/* INFO */}
      {nights() > 0 && (
        <p className="text-center mt-4 text-gray-600">
          {nights()} nuit(s) sélectionnée(s)
        </p>
      )}

      {nights() <= 0 && (
        <p className="text-red-500 text-sm mb-2">
          Dates invalides
        </p>
      )}

      {/* RESULTS */}
      <div className="max-w-6xl mx-auto mt-8 p-4">

        {loading && (
          <div className="grid md:grid-cols-3 gap-6">
            {[1,2,3].map(i => (
              <div key={i} className="h-60 bg-gray-200 animate-pulse rounded-2xl" />
            ))}
          </div>
        )}

        {!loading && results.length === 0 && dateDebut && (
          <p className="text-center text-gray-400">
            Aucun appartement disponible
          </p>
        )}

        <div className="grid md:grid-cols-3 gap-6">
          {results.map(app => (
            <div
              key={app.id}
              className="bg-white rounded-2xl shadow hover:shadow-xl transition overflow-hidden group"
            >
              {/* IMAGE */}
              <div className="relative h-44 bg-gray-200">
                <img
                  src={app.image_url || "https://via.placeholder.com/400"}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                />

                {/* BADGE */}
                <div className="absolute top-2 left-2 bg-white text-xs px-2 py-1 rounded shadow">
                  ⭐ Populaire
                </div>
              </div>

              {/* CONTENT */}
              <div className="p-4">

                <h3 className="font-bold text-lg mb-1">

                  {app.type_logement === "chambre"
                    ? "Chambre"
                    : app.type_logement === "suite"
                    ? "Suite"
                    : "Appartement"}{" "}

                  {app.numero}

                </h3>

                <p className="text-sm text-gray-500 mb-2">
                  👥 2 pers • 📶 Wifi • ❄️ Clim
                </p>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-indigo-600 font-bold">
                    {app.prix_nuitee}$
                  </span>

                  {nights() > 0 && (
                    <span className="text-sm text-gray-500">
                      Total: {app.prix_nuitee * nights()}$
                    </span>
                  )}
                </div>

                <button
                  disabled={!isDateValid()}
                  className={`w-full py-2 rounded-xl text-white transition ${
                    !dateDebut || !dateFin
                      ? "bg-gray-300 cursor-not-allowed opacity-70"
                      : "bg-green-500 hover:bg-green-600"
                  }`}
                  onClick={() => {
                    if (!isDateValid()) return;
                    setSelectedApp(app);
                    setModalOpen(true);
                  }}
                >
                  Réserver
                </button>

              </div>
            </div>
          ))}
        </div>

      </div>

      {(!dateDebut || !dateFin) && (
        <p className="text-center text-sm text-red-500 mt-3">
          ⚠️ Veuillez sélectionner une date d’arrivée et de départ
        </p>
      )}

      {dateDebut && dateFin && !isDateValid() && (
        <p className="text-center text-sm text-red-500 mt-2">
          ❌ La date de départ doit être après la date d’arrivée
        </p>
      )}

      {selectedApp && (
        <BookingModal
          isOpen={modalOpen}
          onClose={() => {
            setModalOpen(false);
            setSelectedApp(null);
          }}
          appartement={selectedApp}
          dates={{ dateDebut, dateFin }}
        />
      )}
    </div>
  );
}